<template>
  <!-- #region template -->
  <div class="w-100" v-if="apps">
    <b-nav vertical class="p-0">
      <div v-for="(app, index) in apps" :key="index">
        <b-nav-text class="text-muted" style="margin-left: -20px; margin-bottom: 5px">{{ app.name }}</b-nav-text>
        <b-nav-item v-for="(dashboard, index) in app.dashboards" :key="index" :to="`?dashboard=${dashboard.name}`" link-classes="text-primary p-0 pb-3" exact exact-active-class="text-primary font-weight-bold">
          <b-icon class="mr-3" :icon="dashboard.icon" aria-hidden="true"></b-icon>
          {{ dashboard.name }}
        </b-nav-item>
      </div>
    </b-nav>
  </div>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import { mapState } from 'vuex'
// #endregion

// #region export
export default {
  name: 'cNav',
  computed: {
    ...mapState({
      apps: (state) => state.app.apps,
    }),
  },
}
// #endregion
// #endregion
</script>
